import axios from 'axios'
import { toast } from 'react-toastify'
import {
  DELETE_ACCOUNT_SUCCESS,
  DELETE_ACCOUNT_ERROR,
  DELETE_ACCOUNT_REQUEST
} from '../constants'

export const deleteAccount = () => async (dispatch, getState) => {
  try {
    dispatch({ type: DELETE_ACCOUNT_REQUEST })

    await axios.post('/user/delete_account')

    dispatch({
      type: DELETE_ACCOUNT_SUCCESS
    })
  } catch (error) {
    const errorMessage =
      error?.response?.data?.Message || 'The request is invalid.'

    dispatch({
      type: DELETE_ACCOUNT_ERROR,
      payload: errorMessage
    })

    toast.error(errorMessage, { autoClose: 3000 })

    return Promise.reject(errorMessage)
  }
}
